import React, { useState } from 'react';
import { Menu, X, Globe } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { motion, AnimatePresence } from 'framer-motion';

const LOGO_URL = '/images/logo-matchpool-clear.png';

const Logo = () => (
  <div className="flex items-center">
    <img src={LOGO_URL} alt="MatchPool.live by GOL.SOCIAL"
      className="h-14 w-auto object-contain"
      style={{ maxWidth: '240px' }} />
  </div>
);

const navLinks = [
  { key: 'howItWorks', href: '#como-funciona' },
  { key: 'forBusiness', href: '#para-negocios' },
  { key: 'tvScreen', href: '#pantalla-tv' },
  { key: 'multiLocation', href: '#multi-sede' },
  { key: 'prizes', href: '#premios' },
];

export default function Header({ onDemoClick }) {
  const { t, lang, toggleLang } = useLanguage();
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="fixed top-0 w-full z-50 bg-[#13191f] border-b border-[#0F6B49]/40 shadow-[0_2px_20px_rgba(0,0,0,0.5)]" data-testid="header">
      <div className="section-container">
        <div className="flex items-center justify-between h-16">
          <a href="#" aria-label="MatchPool.live Home" data-testid="header-logo">
            <Logo />
          </a>

          {/* Desktop Nav */}
          <nav className="hidden lg:flex items-center gap-6" data-testid="desktop-nav">
            {navLinks.map(link => (
              <a key={link.key} href={link.href}
                className="text-[#F3F1EB]/80 hover:text-[#D5A63B] text-sm font-medium transition-colors duration-200 font-[Inter]">
                {t.nav[link.key]}
              </a>
            ))}
          </nav>

          {/* Right actions */}
          <div className="hidden lg:flex items-center gap-3">
            <button onClick={toggleLang}
              className="flex items-center gap-1.5 text-[#F3F1EB]/60 hover:text-[#D5A63B] text-sm font-medium transition-colors px-2 py-1 rounded-lg border border-white/10 hover:border-[#D5A63B]/40"
              data-testid="lang-toggle">
              <Globe size={14} />
              {lang.toUpperCase()}
            </button>
            <a href="https://app.matchpool.live/admin/login"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary text-sm px-4 py-2 no-underline"
              data-testid="header-demo-btn">
              Login / Register
            </a>
          </div>

          {/* Mobile */}
          <div className="flex lg:hidden items-center gap-2">
            <button onClick={toggleLang}
              className="text-[#8A9099] hover:text-[#D5A63B] p-2" data-testid="mobile-lang-toggle">
              <Globe size={16} />
            </button>
            <button onClick={() => setMenuOpen(!menuOpen)}
              className="text-[#F3F1EB] p-2" data-testid="mobile-menu-btn" aria-label="Toggle menu">
              {menuOpen ? <X size={22} /> : <Menu size={22} />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence>
        {menuOpen && (
          <motion.div initial={{ opacity: 0, y: -10 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -10 }}
            className="lg:hidden bg-[#1A222B] border-t border-white/5 px-6 py-4" data-testid="mobile-menu">
            <div className="flex flex-col gap-3">
              {navLinks.map(link => (
                <a key={link.key} href={link.href} onClick={() => setMenuOpen(false)}
                  className="text-[#F3F1EB] font-medium py-2 border-b border-white/5 last:border-0">
                  {t.nav[link.key]}
                </a>
              ))}
              <a href="https://app.matchpool.live/admin/login"
                target="_blank"
                rel="noopener noreferrer"
                className="btn-primary text-center text-sm mt-2 block no-underline"
                data-testid="mobile-demo-btn">
                Login / Register
              </a>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
}
